module.exports = __webpack_public_path__ + "static/img/029 1.5fa4c949.jpg";